import React from 'lib/react';
import {
  EVSelect, EVMenuItem, EVKeyboardArrowDown, EVFormHelperText,
} from 'lib/components';
import PropTypes, { shape } from 'prop-types';

function SelectField(props) {
  const {
    selectId,
    selectedValue,
    handleChange,
    selectOptions,
    errorMessage,
    descriptionKey,
    errorProps,
    innerRef,
    ...rest
  } = props;

  return (
    <>
      <EVSelect
        id={selectId}
        disableUnderline
        value={selectedValue}
        onChange={handleChange}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
        IconComponent={EVKeyboardArrowDown}
        ref={(node) => {
          if (innerRef === null) return;
          if (node !== null && node.firstChild.getAttribute('role') === 'button') {
            innerRef.current = node.firstChild;
          } else {
            innerRef.current = node;
          }
        }}
        {...rest}
      >
        {
        selectOptions
          .map((option) => (
            <EVMenuItem
              id={`${selectId}-${option.id}`}
              value={option.id}
              key={option.id}
            >
              {option[descriptionKey]}
            </EVMenuItem>
          ))
      }
      </EVSelect>
      {errorMessage && <EVFormHelperText error {...errorProps}>{errorMessage}</EVFormHelperText>}
    </>
  );
}

SelectField.defaultProps = {
  selectId: '',
  errorMessage: '',
  descriptionKey: 'description',
  errorProps: {},
  innerRef: null,
};

SelectField.propTypes = {
  selectId: PropTypes.string,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  descriptionKey: PropTypes.string,
  selectOptions: PropTypes.arrayOf(shape).isRequired,
  errorProps: PropTypes.shape(),
  innerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

export default SelectField;
